const getRoutesGroupedBy = (routes, key) => {
  var groups = {}
  var result = []

  routes.forEach(route => {
    if (!(route[key] in groups)) {
      groups[route[key]] = []
      result.push(groups[route[key]])
    }
    groups[route[key]].push(route)
  })

  return result
}

export { getRoutesGroupedBy }
